import { useState, useEffect } from "react";
import "./school.css";
import {
  isEmpty,
  capitalizeAll,
  slugify,
  truncateValue,
} from "../../../../core/utils/helpers";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "../../../../ui/atoms/buttons/Button";
import NotFound from "../../../../ui/organisms/not-found/404";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
//
import {
  onGetStreamsWithPaginationBySchoolId,
  onStreamsReleased,
  onStreamsArchived,
} from "../../services/school";
import { schoolSlice } from "../../../../app/store/slices/schoolSlice";
import Swal from "sweetalert2";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const updated_at = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

const SchoolStreams = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { id, title } = params;
  //
  const [streamsData, setStreamsData] = useState({});
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  //
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);

  const currenSchool = useSelector(
    (state) => state?.schoolState?.currentSchool,
  );

  const _school_id = currenSchool?.school_id;
  const _school_title = currenSchool?.school_title;

  useEffect(() => {
    if (_school_id !== id || slugify(_school_title) !== title) {
      setStreamsData({});
    }
  }, [id, title]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      school_id: _school_id,
      rows_per_page: rowsPerPage,
      current_page: currentPage,
    };

    onGetStreamsWithPaginationBySchoolId(axiosPrivate, localData, signal).then((response) => {
      const _data = response?.data;
      setStreamsData(_data);
    });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [currentPage, isRefresh]);

  const onHandleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
    setCheckedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
  };

  const onHandleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allSchoolsIds = streamsData?.result?.map((item) => item.school_id);
      setSelectedRows(allSchoolsIds);
      setCheckedRows(allSchoolsIds);
    } else {
      setSelectedRows([]);
      setCheckedRows([]);
    }
  };
  const isAllSelected = selectedRows?.length === streamsData?.result?.length;

  const onStreamsReleasing = async (is_action) => {
    Swal.fire({
      title: `Do you really want to ${
        is_action === "released" ? "Release" : "UnRelease"
      } the selected ${selectedRows?.length > 1 ? "streams" : "stream"} ?`,
      text: "This action impact the whole stream(s), and you are able to revert the action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${
        is_action === "released" ? "Release" : "UnRelease"
      }!`,
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform delete action
        //
        Swal.fire({
          title: "Processing...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        // Simulate async operation (e.g., API call)
        onStreamsReleased(axiosPrivate, is_action, selectedRows, updated_at)
          .then((response) => {
            if (response?.data?.status) {
              Swal.close();
              //
              setIsRefresh((prevState) => !prevState);
              //
              Swal.fire(
                `${is_action === "released" ? "Released" : "UnReleased"}!`,
                `The selected stream(s) has been ${
                  is_action === "released" ? "Released" : "UnReleased"
                }!`,
                "success",
              );
              setSelectedRows([]);
              setCheckedRows([]);
            }
          })
          .catch((error) => {
            Swal.close(); // close loading if error
            if (!error?.response) {
              Swal.fire("Error!", "No server response", "error");
            } else {
              Swal.fire(
                "Error!",
                error?.response?.data?.detail?.message,
                "error",
              );
            }
          });
      } else if (
        result.isDismissed ||
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          title: "Cancelled",
          text: "The triggered action was cancelled!",
          icon: "error",
        });
      }
    });
  };

  const onStreamsArchiving = async (is_action) => {
    Swal.fire({
      title: `Do you really want to ${
        is_action === "archived" ? "Archive" : "UnArchive"
      } the selected ${selectedRows?.length > 1 ? "streams" : "stream"} ?`,
      text: "This action impact the whole stream(s), and you are able to revert the action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${
        is_action === "archived" ? "Archive" : "UnArchive"
      }!`,
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform delete action
        //
        Swal.fire({
          title: `${is_action === "archived" ? "Archiving" : "UnArchiving"}...`,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        // Simulate async operation (e.g., API call)
        onStreamsArchived(axiosPrivate, is_action, selectedRows, updated_at)
          .then((response) => {
            if (response?.data?.status) {
              Swal.close();
              //
              setIsRefresh((prevSatte) => !prevSatte);
              //
              Swal.fire(
                `${is_action === "archived" ? "Archived" : "UnArchived"}!`,
                `The selected stream(s) has been ${
                  is_action === "archived" ? "Archived" : "UnArchived"
                }!`,
                "success",
              );
              setSelectedRows([]);
              setCheckedRows([]);
            }
          })
          .catch((error) => {
            Swal.close(); // close loading if error
            if (!error?.response) {
              Swal.fire("Error!", "No server response", "error");
            } else {
              Swal.fire(
                "Error!",
                error?.response?.data?.detail?.message,
                "error",
              );
            }
          });
      } else if (
        result.isDismissed ||
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          title: "Cancelled",
          text: "The triggered action was cancelled!",
          icon: "error",
        });
      }
    });
  };

  return (
    <div className="schools">
      <div className="school-head">
        <h1>
          Streams Management for school of : {capitalizeAll(_school_title)}
        </h1>
        <div className="w-full d-flex justify-space-between align-center">
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"⬅️ Back to School"}
            action={() => navigate(-1)}
          />
          {_school_id === id && slugify(_school_title) === title && (
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"➕ Create new stream"}
              action={() =>
                navigate(
                  `/admin/schools/${slugify(
                    _school_title,
                  )}/${_school_id}/streams/create`,
                )
              }
            />
          )}
          {selectedRows.length > 0 && (
            <div className="sc-actions fade-in">
              {selectedRows.length === 1 && (
                <>
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"👁️ Voir details"}
                    action={() => {}}
                  />
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"🔄 Update infos"}
                    action={() => navigate("")}
                  />
                </>
              )}
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"🔐 Release"}
                action={() => onStreamsReleasing("released")}
              />
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"🔐 UnRelease"}
                action={() => onStreamsReleasing("unreleased")}
              />
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"📌 Archive"}
                action={() => onStreamsArchiving("archived")}
              />
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"📌 UnArchive"}
                action={() => onStreamsArchiving("unarchived")}
              />
            </div>
          )}
        </div>
      </div>
      <div className="school-body">
        {isEmpty(streamsData?.result) ? (
          <NotFound
            type={"data"}
            title={"No Streams found!"}
            text={"No Streams available yet."}
            isBoutton={false}
          />
        ) : (
          <>
            <div className="table">
              <table>
                <thead>
                  <tr>
                    <th className="col-05 text-align-center">
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={onHandleSelectAll}
                      />
                    </th>
                    <th className="col-20 text-align-left">Date of creation</th>
                    <th className="col-25 text-align-left">Name</th>
                    <th className="col-05 text-align-center">
                      Total Inscriptions
                    </th>
                    <th className="col-10 text-align-center">Total Female</th>
                    <th className="col-10 text-align-center">Total Male</th>
                    <th className="col-05 text-align-center">Language</th>
                    <th className="col-05 text-align-center">
                      Status(Visibility)
                    </th>
                    <th className="col-05 text-align-center">
                      Status(Deletion)
                    </th>
                    <th className="col-05 text-align-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {streamsData?.result?.map((stream, idx) => {
                    return (
                      <tr
                        key={idx}
                        className={
                          checkedRows.includes(stream.school_id)
                            ? "row-checked"
                            : ""
                        }
                      >
                        <td className="col-05 text-align-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(stream?.classe_id)}
                            onChange={() =>
                              onHandleSelectRow(stream?.classe_id)
                            }
                          />
                        </td>
                        <td className="col-20 text-align-left">
                          {moment(stream?.classe_created_at).format("LLLL")}
                        </td>
                        <td className="col-25 text-align-left">
                          <h3>{capitalizeAll(stream?.classe_title)}</h3>
                        </td>
                        <td className="col-05 text-align-center">
                          {stream?.classe_Inscriptions}
                        </td>
                        <td className="col-10 text-align-center">
                          {stream?.total_female}
                        </td>
                        <td className="col-10 text-align-center">
                          {stream?.total_male}
                        </td>
                        <td className="col-05 text-align-center">
                          <StatusComponent
                            type={
                              stream?.classe_language === "en"
                                ? "success"
                                : "default"
                            }
                            title={
                              stream?.classe_language === "en"
                                ? "English"
                                : "French"
                            }
                          />
                        </td>
                        <td className="col-05 text-align-center">
                          <StatusComponent
                            type={
                              stream?.classe_is_activated ? "success" : "error"
                            }
                            title={
                              stream?.classe_is_activated
                                ? "Released"
                                : "UnReleased"
                            }
                          />
                        </td>
                        <td className="col-05 text-align-center">
                          <StatusComponent
                            type={
                              stream?.classe_is_deleted ? "error" : "success"
                            }
                            title={
                              stream?.classe_is_deleted
                                ? "Archived"
                                : "UnArchived"
                            }
                          />
                        </td>
                        <td className="col-05 text-align-center">
                          <Button
                            type={"button"}
                            preferedStyle={"default"}
                            title={`more about ${truncateValue(
                              capitalizeAll(stream?.classe_title),
                              7,
                            )}`}
                            action={() => {
                              dispatch(
                                schoolSlice.actions.onCurrentStream(stream),
                              );
                              navigate(
                                `/admin/schools/${slugify(
                                  _school_title,
                                )}/${_school_id}/streams/${slugify(
                                  stream?.classe_title,
                                )}/${stream?.classe_id}/courses`,
                              );
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="pagination">
              <div className="p-wrapper">
                <button
                  className={
                    streamsData?.result_complements?.current_page === 1
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));
                    setSelectedRows([]);
                  }}
                  disabled={streamsData?.result_complements?.current_page === 1}
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {streamsData?.result_complements?.total_pages} pages.
                </span>
                <button
                  className={
                    streamsData?.result_complements?.current_page ===
                    streamsData?.result_complements?.total_pages
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) =>
                      prev <= streamsData?.result_complements?.total_pages
                        ? prev + 1
                        : prev,
                    );
                    setSelectedRows([]);
                  }}
                  disabled={
                    streamsData?.result_complements?.current_page ===
                    streamsData?.result_complements?.total_pages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SchoolStreams;
